// Disable Prism.js auto-highlighting. We trigger it manually in code-blocks.js.
window.Prism = window.Prism || {};
window.Prism.manual = true;
